export const SET_CURRENT_CSV = 'SET_CURRENT_CSV';
export const GET_CURRENT_CSV = 'GET_CURRENT_CSV';
export const SET_CURRENT_EXCEL = 'GET_CURRENT_EXCEL';

export const getUserCurrentCsv = () => ({
    type: GET_CURRENT_CSV,
    payload: null
});

export const setUserCurrentCsv = (userAssets: any) => ({
    type: SET_CURRENT_CSV,
    payload: userAssets
});


export const setUserCurrentExcel = (userAssets: any) => ({
    type: SET_CURRENT_EXCEL,
    payload: userAssets
});